module.exports = __webpack_public_path__ + "img/dometic_tropicool_tcx_14.17b533a2.png";